export default "/assets/markers/undeliverable_on_grayscale.png"